import { createContext, useMemo, useContext } from "react";
import { pluck } from "ramda";
import { useQuery } from "react-query";
import { searchMeasures, getMeasuresMetadataByIds } from "@webapi/api";
import { useAuthContext } from "@authentication/context";
import { isNotEmptyArray } from "utils/validation";
import { jsx as _jsx } from "react/jsx-runtime";
export var MeasuresContext = /*#__PURE__*/createContext({});
export var MeasuresContextProvider = function MeasuresContextProvider(props) {
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var _useQuery = useQuery(["measuresSearch", authTicket], function () {
      return searchMeasures({}, authTicket);
    }, {
      initialData: []
    }),
    measures = _useQuery.data;
  var measureIds = measures && pluck("id", measures);
  var _useQuery2 = useQuery(["measuresMetadata", measureIds, authTicket], function () {
      return getMeasuresMetadataByIds(measureIds, authTicket);
    }, {
      initialData: [],
      enabled: isNotEmptyArray(measureIds)
    }),
    measuresWithMetadata = _useQuery2.data;
  var simpleMeasuresMap = useMemo(function () {
    var mappedMeasures = new Map();
    measures.forEach(function (measure) {
      mappedMeasures.set(measure.id, {
        measureId: measure.id,
        name: measure.name
      });
    });
    return mappedMeasures;
  }, [measures]);
  var measuresMetadataMap = useMemo(function () {
    //1*
    var mappedMeasures = new Map();
    measuresWithMetadata.forEach(function (measure) {
      var _measure$submeasures;
      mappedMeasures.set(measure.measureId, measure); //ask for parent, get parent
      (_measure$submeasures = measure.submeasures) === null || _measure$submeasures === void 0 ? void 0 : _measure$submeasures.map(function (_ref) {
        var measureId = _ref.measureId;
        return mappedMeasures.set(measureId, measure);
      }); //ask for submeasure, get parent
    });

    return mappedMeasures;
  }, [measuresWithMetadata]);

  //We want to provide the full metadata object, but until it finishes loading we provide the simple searchresult object
  var lookupParentMeasure = function lookupParentMeasure(id) {
    return measuresMetadataMap.get(id) || simpleMeasuresMap.get(id) || {};
  };
  return /*#__PURE__*/_jsx(MeasuresContext.Provider, {
    value: {
      lookupParentMeasure: lookupParentMeasure,
      arrayMeasures: measuresWithMetadata //overview only one currently using this one
    },
    children: props.children
  });
};
export var useMeasuresContext = function useMeasuresContext() {
  return useContext(MeasuresContext);
};

/*
1. A measure = parentmeasure that holds metadata for the measure, such as target, soughtValue, etc. The parentmeasure
  also holds information about which submeasures exists for the given measure. The measuresMap is a finished map that makes it easy to fetch
  the metadata regardless if u're currently looking at the actual measure(parentmeasure) or one of the submeasures.

*/